import { Box } from '@mui/system'
import React from 'react'

export default function Footer() {
  return (
    <Box sx={{padding:'15px 0 0 25px'}}>footer</Box>
  )
}
